import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { BrowserDetectionService } from 'src/app/_services/browser-detection.service';
@Component({
  selector: 'app-browser-plugin',
  templateUrl: './browser-plugin.component.html',
  styleUrls: ['./browser-plugin.component.scss']
})
export class BrowserPluginComponent implements OnInit {

  globalSliderData: any[] = [
    { "imgSrc": "/assets/images/google-docs.png", "altText": "google" },
    { "imgSrc": "/assets/images/authorea.png", "altText": "authorea" },
    { "imgSrc": "/assets/images/researchgate.png", "altText": "researchgate" },
    { "imgSrc": "/assets/images/medium.png", "altText": "medium" },
    { "imgSrc": "/assets/images/writing-cooprative.png", "altText": "writing" },
    { "imgSrc": "/assets/images/evernote.png", "altText": "evernote" },
    { "imgSrc": "/assets/images/notion.png", "altText": "notion" },
    { "imgSrc": "/assets/images/linked-in.png", "altText": "linked" },
    { "imgSrc": "/assets/images/twitter.png", "altText": "twitter" },
    { "imgSrc": "/assets/images/gmail.png", "altText": "gmail" }
  ];

  browser: string = '';

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private browserDetectionService: BrowserDetectionService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('免費文法檢查瀏覽器擴充功能－支援 Chrome、Firefox、Edge｜Trinka');
    this.metaTagService.updateTag({ name: 'description', content: "Trinka 免費瀏覽器擴充功能支援 Chrome、Firefox 及 Edge，讓你輕鬆寫出更專業的內容！即時提供文法檢查與修改建議，提升寫作效率與準確度。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka浏览器插件" });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka 免費瀏覽器擴充功能支援 Chrome、Firefox 及 Edge，讓你輕鬆寫出更專業的內容！即時提供文法檢查與修改建議，提升寫作效率與準確度。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/browser-plugin' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/browser-plugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/browser-plugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/browser-plugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/browser-plugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/browser-plugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/browser-plugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/browser-plugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/browser-plugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/browser-plugin' });
    
    this.browser = this.browserDetectionService.getBrowserName();
  }
  
}
